import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { DirectAccessGuard } from './guards/direct-access.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './home/home.module#HomePageModule', data: { preload: true, delay: false }},
  { path: 'history/:assetId', loadChildren: './detail/detail.module#DetailPageModule', data: { preload: true, delay: false }, canActivate: [DirectAccessGuard]},
  { path: 'history/:assetId/add', loadChildren: './add-stage/add-stage.module#AddStagePageModule', data: { preload: true, delay: false }, canActivate: [DirectAccessGuard] },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule],
  providers: [
    DirectAccessGuard,
  ]
})
export class AppRoutingModule { }
